// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Record from "../Data.Record/index.js";
import * as Data_Record_Extra2 from "../Data.Record.Extra2/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Variant_Tag from "../Data.Variant.Tag/index.js";
import * as Heterogeneous_Mapping from "../Heterogeneous.Mapping/index.js";
import * as Record from "../Record/index.js";
import * as Restaumatic_Form_DynamicResult from "../Restaumatic.Form.DynamicResult/index.js";
import * as Restaumatic_Form_Final from "../Restaumatic.Form.Final/index.js";
import * as Restaumatic_I18n from "../Restaumatic.I18n/index.js";
import * as Safe_Coerce from "../Safe.Coerce/index.js";
import * as Specular_Select from "../Specular.Select/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(Restaumatic_Form_DynamicResult.applicativeDynamicResult);
var join = /* #__PURE__ */ Control_Bind.join(Data_Maybe.bindMaybe);
var getField = /* #__PURE__ */ Data_Record.getField(/* #__PURE__ */ Data_Record.hasFieldRecord({
    reflectSymbol: function () {
        return "label";
    }
})());
var merge = /* #__PURE__ */ Record.merge()();
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Data_Functor.functorArray);
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var coerce = /* #__PURE__ */ Safe_Coerce.coerce();
var AddOptions = function (x) {
    return x;
};
var mappingWithIndexAddOption = function (dictIsSymbol) {
    return function (dictMaybeGet) {
        var maybeGet = Data_Record_Extra2.maybeGet(dictMaybeGet);
        return {
            mappingWithIndex: function (v) {
                return function (v1) {
                    return function (label) {
                        return {
                            label: pure(label),
                            options: Restaumatic_Form_Final.liftMaybe(join(maybeGet(v)))
                        };
                    };
                };
            }
        };
    };
};
var gSumTypeOptionsConstructo = function (dictIsSymbol) {
    var mkTag = Data_Variant_Tag.mkTag(dictIsSymbol)();
    return function (dictGetTranslation) {
        var getTranslation = Restaumatic_I18n.getTranslation(dictGetTranslation);
        return function (dictHasField) {
            var getField1 = Data_Record.getField(dictHasField);
            return function (dictHasField1) {
                var getField2 = Data_Record.getField(dictHasField1);
                return function () {
                    return {
                        gGetSumTypeOptions: function (p) {
                            return function (v) {
                                return [ new Data_Tuple.Tuple(mkTag(Type_Proxy["Proxy"].value), getField2(Type_Proxy["Proxy"].value)(getField1(Type_Proxy["Proxy"].value)(getTranslation(p)))) ];
                            };
                        }
                    };
                };
            };
        };
    };
};
var gEnumOptionsConstructorNo = function (dictIsSymbol) {
    return function (dictGetTranslation) {
        var getTranslation = Restaumatic_I18n.getTranslation(dictGetTranslation);
        return function (dictHasField) {
            var getField1 = Data_Record.getField(dictHasField);
            return {
                gGetEnumOptions: function (p) {
                    return function (wrap) {
                        return [ new Data_Tuple.Tuple(wrap(Data_Generic_Rep.NoArguments.value), getField(Type_Proxy["Proxy"].value)(getField1(Type_Proxy["Proxy"].value)(getTranslation(p)))) ];
                    };
                }
            };
        };
    };
};
var withTranslations = function (dictIsSymbol) {
    var insert = Record.insert(dictIsSymbol)()();
    return function (dictGetTranslation) {
        var getTranslation = Restaumatic_I18n.getTranslation(dictGetTranslation);
        return function () {
            return function () {
                return function () {
                    return function (rec) {
                        var v = insert(Type_Proxy["Proxy"].value)(getTranslation(Type_Proxy["Proxy"].value))({});
                        return merge(v)(rec);
                    };
                };
            };
        };
    };
};
var getOptions = function (dict) {
    return dict.getOptions;
};
var getFieldOptions = function (dict) {
    return dict.getFieldOptions;
};
var gGetSumTypeOptions = function (dict) {
    return dict.gGetSumTypeOptions;
};
var getSumTypeOptions = function (dictGeneric) {
    var repOf = Data_Generic_Rep.repOf(dictGeneric);
    return function (dictGSumTypeOptions) {
        return mapFlipped(gGetSumTypeOptions(dictGSumTypeOptions)(Type_Proxy["Proxy"].value)(repOf(Type_Proxy["Proxy"].value)))(function (v) {
            return new Specular_Select.SingleOption({
                key: v.value0,
                label: v.value1,
                disabled: false
            });
        });
    };
};
var gSumTypeOptionsSum = function (dictGSumTypeOptions) {
    var gGetSumTypeOptions1 = gGetSumTypeOptions(dictGSumTypeOptions);
    return function (dictGSumTypeOptions1) {
        var gGetSumTypeOptions2 = gGetSumTypeOptions(dictGSumTypeOptions1);
        return function () {
            return function () {
                return {
                    gGetSumTypeOptions: function (p) {
                        return function (v) {
                            return append(mapFlipped(gGetSumTypeOptions1(p)(Type_Proxy["Proxy"].value))(function (v1) {
                                return new Data_Tuple.Tuple(coerce(v1.value0), v1.value1);
                            }))(mapFlipped(gGetSumTypeOptions2(p)(Type_Proxy["Proxy"].value))(function (v1) {
                                return new Data_Tuple.Tuple(coerce(v1.value0), v1.value1);
                            }));
                        };
                    }
                };
            };
        };
    };
};
var gGetEnumOptions = function (dict) {
    return dict.gGetEnumOptions;
};
var getEnumOptions = function (dictGeneric) {
    var to = Data_Generic_Rep.to(dictGeneric);
    return function (dictBoundedEnum) {
        return function (dictEnum) {
            return function (dictGEnumOptions) {
                return mapFlipped(gGetEnumOptions(dictGEnumOptions)(Type_Proxy["Proxy"].value)(to))(function (v) {
                    return new Specular_Select.SingleOption({
                        key: v.value0,
                        label: v.value1,
                        disabled: false
                    });
                });
            };
        };
    };
};
var gEnumOptionsSum = function (dictGEnumOptions) {
    var gGetEnumOptions1 = gGetEnumOptions(dictGEnumOptions);
    return function (dictGEnumOptions1) {
        var gGetEnumOptions2 = gGetEnumOptions(dictGEnumOptions1);
        return {
            gGetEnumOptions: function (p) {
                return function (wrap) {
                    return append(gGetEnumOptions1(p)(function ($110) {
                        return wrap(Data_Generic_Rep.Inl.create($110));
                    }))(gGetEnumOptions2(p)(function ($111) {
                        return wrap(Data_Generic_Rep.Inr.create($111));
                    }));
                };
            }
        };
    };
};
var addOptions = function (dictHMapWithIndex) {
    var $112 = Heterogeneous_Mapping.hmapWithIndex(dictHMapWithIndex);
    return function ($113) {
        return $112(AddOptions($113));
    };
};
var getMetadata = function (dictGetTranslation) {
    var getTranslation = Restaumatic_I18n.getTranslation(dictGetTranslation);
    return function (dictGetFieldOptions) {
        var getFieldOptions1 = getFieldOptions(dictGetFieldOptions);
        return function (dictHMapWithIndex) {
            var addOptions1 = addOptions(dictHMapWithIndex);
            return function (p) {
                var ts = getTranslation(p);
                var opt = getFieldOptions1(p);
                return addOptions1(opt)(ts);
            };
        };
    };
};
var mappingWithIndexAddOption1 = function (dictIsSymbol) {
    return function (dictMaybeGet) {
        var maybeGet = Data_Record_Extra2.maybeGet(dictMaybeGet);
        return function (dictHMapWithIndex) {
            var addOptions1 = addOptions(dictHMapWithIndex);
            return function (dictHMapWithIndex1) {
                var addOptions2 = addOptions(dictHMapWithIndex1);
                return {
                    mappingWithIndex: function (v) {
                        return function (v1) {
                            return function (labels) {
                                var v2 = maybeGet(v);
                                if (v2 instanceof Data_Maybe.Just) {
                                    return addOptions1(v2.value0)(labels);
                                };
                                if (v2 instanceof Data_Maybe.Nothing) {
                                    return addOptions2({})(labels);
                                };
                                throw new Error("Failed pattern match at Restaumatic.Form.Metadata (line 54, column 50 - line 56, column 72): " + [ v2.constructor.name ]);
                            };
                        };
                    }
                };
            };
        };
    };
};
export {
    gGetEnumOptions,
    gGetSumTypeOptions,
    getFieldOptions,
    getOptions,
    getMetadata,
    addOptions,
    AddOptions,
    getEnumOptions,
    getSumTypeOptions,
    withTranslations,
    mappingWithIndexAddOption,
    mappingWithIndexAddOption1,
    gEnumOptionsSum,
    gEnumOptionsConstructorNo,
    gSumTypeOptionsSum,
    gSumTypeOptionsConstructo
};
